var Register = function() {

		var validation = new Validation();
		var wWidth = $(window).width();
		var url_atual = window.location.href.replace('#', '');
		var customer;
		var dadospost;

		function init() {
				Nationality();
				insertMask();
				$('#legal-person').click();
				$('#name-nationality').val('35').change();
		};

		function Nationality() {

				var checkNationality;
				var form = $('.form-step-3');

				$(".txtCep").on("blur", function() {
						var input = $(this);
						var classCep = "." + input.attr('data-cep');
						cepChange(input.val().replace("-", ""), classCep);
				});

				$('[data-page="cadastro"] #password').keyup(function() {

						return CheckPassStrength();

				});

				$('.person-type').on('click', function() {
						checkPerson = $(this);

						$('#cpf').val('');
						$('#cpf').focus();

						if ($(checkPerson).hasClass('physical-person')) {

								document.getElementById('physical-person').click();

								$('[name="cpf"]').mask('000.000.000-00', { reverse: true });

								if (wWidth > 992) {

										$(checkPerson).find('.icon-physical-person').css('display', 'none');
										$(checkPerson).find('.icon-physical-person-white').css('display', 'block');
										$('.legal-person').find('.icon-legal-person-white').css('display', 'none');
										$('.legal-person').find('.icon-legal-person').css('display', 'block');
										$(checkPerson).find('h6').css('color', '#fff');
										$(checkPerson).css({
												'background-color': '#3eba9e',
												'opacity': '1',
												'border-color': '#3eba9e'
										});
										$('.legal-person').css({
												'background-color': '#fff',
												'opacity': '0.5',
												'border-color': '#666'
										});
										$('.legal-person').find('h6').css('color', '#666');
										$('#cpf').prev('label').text('CPF');
                                    	var selector = $('#cpf').parent().find('.form-error-message');
                                    	selector.text(selector.attr("data-cpf"));
								} else {
										$(checkPerson).css({
												'background-color': '#3eba9e',
												'opacity': '1',
												'border-color': '#3eba9e'
										});
										$('.legal-person').css({
												'background-color': 'transparent',
												'opacity': '0.5',
												'border-color': '#666'
										});
										$('#cpf').prev('label').text('CPF');
                                    	var selector = $('#cpf').parent().find('.form-error-message');
                                    	selector.text(selector.attr("data-cpf"));
								}

						} else {
								document.getElementById('legal-person').click();

								$('[name="cpf"]').mask('99.999.999/9999-99');

								if (wWidth > 992) {

										$(checkPerson).find('.icon-legal-person').css('display', 'none');
										$(checkPerson).find('.icon-legal-person-white').css('display', 'block');
										$('.physical-person').find('.icon-physical-person-white').css('display', 'none');
										$('.physical-person').find('.icon-physical-person').css('display', 'block');
										$(checkPerson).css({
												'background-color': '#3eba9e',
												'opacity': '1',
												'border-color': '#3eba9e'
										});
										$(checkPerson).find('h6').css('color', '#fff');
										$('.physical-person').css({
												'background-color': '#fff',
												'opacity': '0.5',
												'border-color': '#666'
										});
										$('.physical-person').find('h6').css('color', '#666');
										$('#cpf').prev('label').text('CNPJ');
                                    	var selector = $('#cpf').parent().find('.form-error-message');
                                    	selector.text(selector.attr("data-cnpj"));
								} else {
										$(checkPerson).css({
												'background-color': '#3eba9e',
												'opacity': '1',
												'border-color': '#3eba9e'
										});
										$('.physical-person').css({
												'background-color': 'transparent',
												'opacity': '0.5',
												'border-color': '#666'
										});
										$('#cpf').prev('label').text('CNPJ');
                                    	var selector = $('#cpf').parent().find('.form-error-message');
                                    	selector.text(selector.attr("data-cnpj"));
								}

						}
				});

				$('.employee > h6').on('click', function() {
						$(this).parent().find('ul').toggleClass('show');
						$(this).find('.icon-arrow-down').toggleClass('topUp');
						$(this).find('.icon-arrow-down-white').toggleClass('topUp');
				})
				$('.branch > h6').on('click', function() {
						$(this).parent().find('ul').toggleClass('show');
						$(this).find('.icon-arrow-down').toggleClass('topUp');
						$(this).find('.icon-arrow-down-white').toggleClass('topUp');
				})
				$('.branch-type li').on('click', function() {
						var branch = $(this).text();
						$('#branch').val(branch);

						$('.branch-type').removeClass('show');
						$('.icon-arrow-down').removeClass('topUp');
						$('.icon-arrow-down-white').removeClass('topUp');
						validationFormStep_3($(this));
				})

				$('.employee ul li').on('click', function() {
						var employee = $(this).text();
						form.find('input[name="employee"]').val(employee);

						$('.employee-quantity').removeClass('show');
						$('.icon-arrow-down').removeClass('topUp');
						$('.icon-arrow-down-white').removeClass('topUp');
						validationFormStep_3($(this));
				})

				$('.technical , #technical-contact').on('click', function() {

						if ($('#technical-contact').prop('checked')) {
								$('#technical-contact').removeAttr('checked');
								$('.technical').find('.icon-check').css('display', 'none');
								$(this).find('.icon-check').css('display', 'none');
								form.find('#technical-name-label').removeClass("ToTop");
								form.find('input[name="technical-name"]').val("").prop('readonly', false);
								form.find('#technical-email-label').removeClass("ToTop");
								form.find('input[name="technical-email"]').val("").prop('readonly', false);
						} else {

								$('#technical-contact').prop('checked', true);
								$('.technical').find('.icon-check').css('display', 'block');
								form.find('#technical-name-label').addClass("ToTop");
								form.find('input[name="technical-name"]').val(customer.name).prop("readonly", true);
								form.find('#technical-email-label').addClass("ToTop");
								form.find('input[name="technical-email"]').val(customer.email).prop("readonly", true);
						}

						validationFormStep_3($(this));
				})

				$('.financial , #financial-contact').on('click', function() {

						if ($('#financial-contact').prop('checked')) {
								$('#financial-contact').removeAttr('checked');
								$('.financial').find('.icon-check').css('display', 'none');
								form.find('#financial-name-label').removeClass("ToTop");
								form.find('input[name="financial-name"]').val("").prop('readonly', false);
								form.find('#financial-email-label').removeClass("ToTop");
								form.find('input[name="financial-email"]').val("").prop('readonly', false);
						} else {
								$('#financial-contact').prop('checked', true);
								$('.financial').find('.icon-check').css('display', 'block');
								form.find('#financial-name-label').addClass("ToTop");
								form.find('input[name="financial-name"]').val(customer.name).prop('readonly', true);
								form.find('#financial-email-label').addClass("ToTop");
								form.find('input[name="financial-email"]').val(customer.email).prop('readonly', true);

						}
						validationFormStep_3($(this));
				})


				$('.btn-step-1').on('click', function(e) {
						e.preventDefault()
						// $('body').css('overflow', 'auto');
						var form = $('.form-step-1');

						if ($(this).hasClass('btn-green')) {
								form.submit();
						}
				})

				$('.btn-step-2').on('click', function(e) {
					e.preventDefault()
					// $('body').css('overflow', 'auto');

					var form = $('.form-step-2');

					if ($(this).hasClass('btn-green')) {
							form.submit();
					}
			})

			$('.btn-see-privacy').on('click', function(e) {
					e.preventDefault()
					// $('body').css('overflow', 'auto');

					var form = $('.btn-see-privacy');

					if ($(this).hasClass('btn-green')) {
							form.submit();
					}

			})


				$('.btn-step-3').on('click', function(e) {
						e.preventDefault()
						// $('body').css('overflow', 'auto');
						var form = $('.form-step-3');

						if ($(this).hasClass('btn-green')) {
								form.submit();
						}
				})

		};


		$('.form-step-1 .form-control').on('keyup', function() {

				validationFormStep_1($(this));

		});

		$('.form-step-2 .form-control').on('keyup', function() {

				validationFormStep_2($(this));

		});

		$('.form-step-3 .form-control').on('keyup', function() {

				validationFormStep_3($(this));

		});

		function validationFormStep_1(input) {
				var error = false;
				var form = $('.form-step-1');

				var name = form.find('[name="name"]');
				var email = form.find('[name="email"]');
				var senha = form.find('[name="password"]');
				var repetirSenha = form.find('[name="repeat-password"]');

				var senhaMin = 4;

				if (validation.isNull(name.val())) {
						error = true;
						if ($(name).attr('id') == $(input).attr('id')) {
								name.addClass('error');
                            	name.next('.form-error-message').removeClass('form-error-message-hide');
						}

				} else {
						name.removeClass('error');
                    	name.next('.form-error-message').addClass('form-error-message-hide');
				}

				if (!validation.IsEmail(email.val()) || validation.isNull(email.val())) {
						error = true;
						if ($(email).attr('id') == $(input).attr('id')) {
								email.addClass('error');
                            	email.next('.form-error-message').removeClass('form-error-message-hide');
						}
				} else {
						email.removeClass('error');
                    	email.next('.form-error-message').addClass('form-error-message-hide');
				}

				if (senha.val().length < senhaMin || validation.isNull(senha.val())) {
						error = true;
						if ($(senha).attr('id') == $(input).attr('id')) {
								senha.addClass('error');
                            	senha.parent().find('.form-error-message').removeClass('form-error-message-hide');
						}
				} else {
						senha.removeClass('error');
                    	senha.parent().find('.form-error-message').addClass('form-error-message-hide');
				}

				if (validation.isNull(repetirSenha.val()) || repetirSenha.val() != senha.val()) {
						error = true;
						if ($(repetirSenha).attr('id') == $(input).attr('id')) {
								repetirSenha.addClass('error');
                            	repetirSenha.next('.form-error-message').removeClass('form-error-message-hide');
						}
				} else {
						repetirSenha.removeClass('error');
                    	repetirSenha.next('.form-error-message').addClass('form-error-message-hide');
				}

				if (!error) {

						$('.btn-step-1').addClass('btn-green');
						$('.btn-step-1').removeClass('btn-register');
				} else {
						$('.btn-step-1').addClass('btn-register');
						$('.btn-step-1').removeClass('btn-green');
				}
		};

		function validationFormStep_2(input) {
				var error = false;
				var form = $('.form-step-2');

				if ($('#name-nationality').val() == '35') {

						var tipoPessoa = $('input[name=person-type]:checked');
						var nacionalidade = $('#name-nationality');
						var cpf = form.find('[name="cpf"]');
						var cep = form.find('[name="zip-code"]');
						var logradouro = form.find('[name="street"]');
						var cidade = form.find('[name="city"]');
						var estado = form.find('[name="state"]');
						var numero = form.find('[name="number"]');

						if (validation.isNull(tipoPessoa.val())) {
								error = true;
								if ($(tipoPessoa).attr('id') == $(input).attr('id')) {
										$('.person-type').addClass('error');
								}

						} else {
								$('.person-type').removeClass('error');
						}

						if (validation.isNull(nacionalidade.val())) {
								error = true;
								if ($(nacionalidade).attr('id') == $(input).attr('id')) {
										$('.nationality').addClass('error');
								}

						} else {
								$('.nationality').removeClass('error');
						}

						if ($('#cpf').prev('label').text() == 'CPF') {

								if (validation.isNull(cpf.val()) || !validation.verifyCPF(cpf.val())) {
										error = true;
										cpf.addClass('error');
                                    	cpf.next('.form-error-message').removeClass('form-error-message-hide');

								} else {
										cpf.removeClass('error');
                                    	cpf.next('.form-error-message').addClass('form-error-message-hide');
								}
						} else {

								if (validation.isNull(cpf.val()) || !validation.verifyCNPJ(cpf.val())) {
										error = true;
										cpf.addClass('error');
                                    	cpf.next('.form-error-message').removeClass('form-error-message-hide');

								} else {
										cpf.removeClass('error');
                                    	cpf.next('.form-error-message').addClass('form-error-message-hide');
								}
						}

						if (validation.isNull(logradouro.val())) {
								error = true;
								if ($(logradouro).attr('id') == $(input).attr('id')) {
										logradouro.addClass('error');
                                    	logradouro.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								logradouro.removeClass('error');
                            	logradouro.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(cep.val())) {
								error = true;
								if ($(cep).attr('id') == $(input).attr('id')) {
										cep.addClass('error');
                                    	cep.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								cep.removeClass('error');
                            	cep.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(cidade.val())) {
								error = true;
								if ($(cidade).attr('id') == $(input).attr('id')) {
										cidade.addClass('error');
                                    	cidade.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								cidade.removeClass('error');
                            	cidade.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(estado.val())) {
								error = true;
								if ($(estado).attr('id') == $(input).attr('id')) {
										estado.addClass('error');
                                    	estado.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								estado.removeClass('error');
                            	estado.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(numero.val())) {
								error = true;
								if ($(numero).attr('id') == $(input).attr('id')) {
										numero.addClass('error');
                                    	numero.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								numero.removeClass('error');
                            	numero.next('.form-error-message').addClass('form-error-message-hide');
						}

				} else {

						var tipoPessoa = $('input[name=person-type]:checked');
						var nacionalidade = $('#name-nationality');
						var nomeNacionalidade = form.find('[name="name-nationality"]');
						var cep = form.find('[name="zip-code"]');
						var logradouro = form.find('[name="street"]');
						var cidade = form.find('[name="city"]');
						var estado = form.find('[name="state"]');
						var numero = form.find('[name="number"]');

						if (validation.isNull(tipoPessoa.val())) {
								error = true;
								if ($(tipoPessoa).attr('id') == $(input).attr('id')) {
										$('.person-type').addClass('error');
								}

						} else {
								$('.person-type').removeClass('error');
						}

						if (validation.isNull(nacionalidade.val())) {
								error = true;
								if ($(nacionalidade).attr('id') == $(input).attr('id')) {
										$('.nationality').addClass('error');
								}

						} else {
								$('.nationality').removeClass('error');
						}

						if (validation.isNull(nomeNacionalidade.val())) {
								error = true;
								if ($(nomeNacionalidade).attr('id') == $(input).attr('id')) {
										nomeNacionalidade.addClass('error');
                                    	nomeNacionalidade.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								nomeNacionalidade.removeClass('error');
                            	nomeNacionalidade.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(logradouro.val())) {
								error = true;
								if ($(logradouro).attr('id') == $(input).attr('id')) {
										logradouro.addClass('error');
                                    	logradouro.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								logradouro.removeClass('error');
                            	logradouro.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(cep.val())) {
								error = true;
								if ($(cep).attr('id') == $(input).attr('id')) {
										cep.addClass('error');
                                    	cep.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								cep.removeClass('error');
                            	cep.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(cidade.val())) {
								error = true;
								if ($(cidade).attr('id') == $(input).attr('id')) {
										cidade.addClass('error');
                                    	cidade.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								cidade.removeClass('error');
                            	cidade.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(estado.val())) {
								error = true;
								if ($(estado).attr('id') == $(input).attr('id')) {
										estado.addClass('error');
                                    	estado.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								estado.removeClass('error');
                            	estado.next('.form-error-message').addClass('form-error-message-hide');
						}

						if (validation.isNull(numero.val())) {
								error = true;
								if ($(numero).attr('id') == $(input).attr('id')) {
										numero.addClass('error');
                                    	numero.next('.form-error-message').removeClass('form-error-message-hide');
								}

						} else {
								numero.removeClass('error');
                            	numero.next('.form-error-message').addClass('form-error-message-hide');
						}

				}

				if (!error) {
						$('.btn-step-2').addClass('btn-green');
						$('.btn-step-2').removeClass('btn-register');
						$('.btn-see-privacy').addClass('btn-green-2');
						$('.btn-see-privacy').removeClass('btn-register');
				} else {
						$('.btn-step-2').addClass('btn-register');
						$('.btn-step-2').removeClass('btn-green');
						$('.btn-see-privacy').removeClass('btn-register btn-green-2');
				}


		};

		function validationFormStep_3(input) {
				var error = false;
				var form = $('.form-step-3');

				var qntEmpregados = $('input[name=employee]');
				var ramo = $('input[name=branch]');
				var nomeTecnico = form.find('[name="technical-name"]');
				var emailTecnico = form.find('[name="technical-email"]');
				var contatoFinanceiro = form.find('[name="financial-name"]');
				var emailCcontatoFinanceiro = form.find('[name="financial-email"]');

				if (validation.isNull(qntEmpregados.val())) {
						error = true;
						if ($(qntEmpregados).attr('id') == $(input).attr('id')) {
								$('.employee').addClass('error');
						}

				} else {
						$('.employee').removeClass('error');
				}

				if (validation.isNull(ramo.val())) {
						error = true;
						if ($(ramo).attr('id') == $(input).attr('id')) {
								$('.branch').addClass('error');
						}

				} else {
						$('.branch').removeClass('error');
				}

				if (validation.isNull(nomeTecnico.val())) {
						error = true;
						if ($(nomeTecnico).attr('id') == $(input).attr('id')) {
								nomeTecnico.addClass('error');
						}

				} else {
						nomeTecnico.removeClass('error');
				}

				if (!validation.IsEmail(emailTecnico.val()) || validation.isNull(emailTecnico.val())) {
						error = true;
						if ($(emailTecnico).attr('id') == $(input).attr('id')) {
								emailTecnico.addClass('error');
						}

				} else {
						emailTecnico.removeClass('error');
				}

				if (validation.isNull(contatoFinanceiro.val())) {
						error = true;
						if ($(contatoFinanceiro).attr('id') == $(input).attr('id')) {
								contatoFinanceiro.addClass('error');
						}

				} else {
						contatoFinanceiro.removeClass('error');
				}

				if (!validation.IsEmail(emailCcontatoFinanceiro.val()) || validation.isNull(emailCcontatoFinanceiro.val())) {
						error = true;
						if ($(emailCcontatoFinanceiro).attr('id') == $(input).attr('id')) {
								emailCcontatoFinanceiro.addClass('error');
						}

				} else {
						emailCcontatoFinanceiro.removeClass('error');
				}

				if (!error) {
						$('.btn-step-3').addClass('btn-green');
						$('.btn-step-3').removeClass('btn-register');
				} else {
						$('.btn-step-3').addClass('btn-register');
						$('.btn-step-3').removeClass('btn-green');
				}

		};

		$(".form-step-1").on('submit', function(e) {
				e.preventDefault();
				var form = $(this);
				TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
				$.ajax({
						url: url_atual + '/step1',
						type: 'POST',
						data: form.serialize(),
						dataType: 'json',
						success: function(result) {
								if (result != null) {
										if (result.success) {
												customer = result.step1;
												dadospost = form.serialize();
												TweenMax.fromTo($('[data-component="register-step-1"]'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												TweenMax.fromTo($('[data-component="register-step-2"]'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });

												TweenMax.fromTo($('.bg-right-blue'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												if (wWidth > 992) {
														TweenMax.fromTo($('.bg-right-purple'), 1, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
														// TweenMax.to($('[data-page="cadastro"]'), 1, { backgroundColor: '#8071b4', ease: Power1.easeOut });
												} else {
														// TweenMax.to($('[data-page="cadastro"]'), 1, { backgroundColor: '#8071b4', ease: Power1.easeOut });
														// TweenMax.fromTo($('[data-page="cadastro"]'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
												}

												TweenMax.to($('.right'), 1, { backgroundColor: '#8071b4', ease: Power1.easeOut });
												TweenMax.fromTo($(".icon-connect"), 1, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												TweenMax.fromTo($(".icon-secure-connect"), 1, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
												TweenLite.to('html,body', 1, { scrollTop: 0, ease: Power1.easeOut });
												$('[data-page="cadastro"] .right').css('height', '1060px');
												$('[data-page="cadastro"] .bg-right-purple').css('height', '1060px');
										} else {
												alert('Erro! ' +result.message);
										}
								}
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {
								console.log("Erro: " + errorThrown);
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						}
				});

		});
		$(".form-step-2").on('submit', function(e) {
				e.preventDefault();
				var form = $(this);
				var personType;
				dadospost = dadospost + '&' + form.serialize();
				TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
				$.ajax({
						url: url_atual + '/step2',
						type: 'POST',
						data: dadospost,
						dataType: 'json',
						headers: {
								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						},
						success: function(result) {
								if (result != null) {
										if (result.success == true) {
												$('#identification').val($('#cpf').val());
												customerStep2 = result.step2;
												personType = customerStep2['person-type'];
												customer = Object.assign({}, customer, customerStep2);
												if (personType == 'PJ') {
														TweenMax.fromTo($('[data-component="register-step-2"]'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
														TweenMax.fromTo($('[data-component="register-step-3"]'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
														TweenMax.fromTo($(".icon-enterprise"), 1, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
														TweenMax.fromTo($(".icon-secure-connect"), 1, { css: { alpha: 0, display: 'none' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
														if (wWidth > 1366) {
																$('[data-page="cadastro"]').css('position', 'relative');
																$('.bg-right-purple').css('height', '100%');
																$('.right').css('height', '100%');
														}

														// TweenLite.to('html,body', 1, { scrollTop: 0, ease: Power1.easeOut });
												}
										} else if (result.error) {
												alert('Erro!' + JSON.stringify(result.message));
										}
								}
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {
								console.log("Erro");
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						},
						complete: function() {
								if (personType == 'PF') {
										$.ajax({
												url: url_atual + '/complete',
												type: 'POST',
												data: dadospost,
												dataType: 'json',
												headers: {
														'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
												},
												success: function(result) {
														if (result != null) {
																if (result.success == true) {
																		window.location.href = result.complete;
																} else if (result.error) {
																		alert('Erro!' + JSON.stringify(result.message));
																}
														}
														TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												},
												error: function(XMLHttpRequest, textStatus, errorThrown) {
														TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												},
												complete: function(result){
													console.log(result);
												}
										});
								}

						}
				});

		});

		$(".form-step-3").on('submit', function(e) {
				e.preventDefault();
				var form = $(this);
				var personType;
				dadospost = dadospost + '&' + form.serialize();
				TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
				$.ajax({
						url: url_atual + '/step3',
						type: 'POST',
						data: dadospost,
						dataType: 'json',
						headers: {
								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						},
						success: function(result) {
								if (result != null) {
										if (result.success == true) {
												// TweenMax.fromTo($('[data-component="register-step-3"]'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
												// TweenMax.fromTo($('[data-component="register-step-4"]'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});


												// if(wWidth > 992){
												// 	TweenMax.fromTo($('.bg-right-blue'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
												// 	TweenMax.fromTo($('.bg-right-green'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
												// 	TweenMax.to($('.right'), 1, { backgroundColor: '#00b5ad', ease:Power1.easeOut});
												// }else{
												// 	$('.bg-right-green').css('display','none');
												// 		// TweenMax.to($('[data-page="cadastro"]'), 1, { backgroundColor: '#8071b4', ease:Power1.easeOut});
												// 		// TweenMax.fromTo($('[data-page="cadastro"]'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
												// 	}
												// 	TweenLite.to('html,body', 1, {scrollTop:0, ease:Power1.easeOut});
												// 	$('[data-page="cadastro"] .right').css('height','100vh');
												// 	$('[data-page="cadastro"] .bg-right-green').css('height','100vh');
												// 	$('[data-page="cadastro"] .bg-right-purple').css('display','none');
												// customerStep3 = result.step3;
												// customer = Object.assing({}, customer, customerStep3);

										} else if (result.error) {
												alert('Verifique todos os campos.');
										}
								}
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {
								console.log(XMLHttpRequest);
								console.log(textStatus);
								console.log(errorThrown);
								console.log("Erro");
								TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
						},
						complete: function() {
									$.ajax({
											url: url_atual + '/complete',
											type: 'POST',
											data: dadospost,
											dataType: 'json',
											headers: {
													'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
											},
											success: function(result) {
													if (result != null) {
															if (result.success) {
																	window.location.href = result.complete;
															} else if (result.error) {
																	alert('Erro!' + JSON.stringify(result.message));
															}
													}
													TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
											},
											error: function(XMLHttpRequest, textStatus, errorThrown) {
													console.log("Erro");
													TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
											}
									});
						}
				});

		});

		function insertMask() {

				$('[name="cep"]').mask('00000-000');
				$('[name="zip-code"]').mask('99999-999');

		};

		function limpa_formulario_cep() {
				$("#logradouro").val('');
				$("#cidade").val('');
				$("#estado").val('');
				$("#street").val('');
				$("#city").val('');
				$("#state").val('');
		}

		function cepChange(cep, inputCep) {
				if ($('#name-nationality').val() == '35') {
						// var loading = new Loading();
						TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });

						//Nova variÃ¡vel "cep" somente com dÃ­gitos.
						var cep = cep.replace(/\D/g, '');

						//Verifica se campo cep possui valor informado.
						if (cep != "") {

								//ExpressÃ£o regular para validar o CEP.
								var validacep = /^[0-9]{8}$/;

								//Valida o formato do CEP.
								if (validacep.test(cep)) {

										//Preenche os campos com "..." enquanto consulta webservice.
										$(inputCep).find("#logradouro").val("...");
										$(inputCep).find("#cidade").val("...");
										$(inputCep).find("#estado").val("...");

										//Consulta o webservice viacep.com.br/
										$.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function(dados) {

												if (!("erro" in dados)) {
														//Atualiza os campos com os valores da consulta.
														$('[data-component="brasilian"]').find('.form-anim').removeClass('hidden');
														$(inputCep).find("#street").val(dados.logradouro);
														$(inputCep).find("#city").val(dados.localidade);
														$(inputCep).find("#state").val(dados.uf);
														$("#street").prev('label').addClass('ToTop');
														$("#city").prev('label').addClass('ToTop');
														$("#state").prev('label').addClass('ToTop');
														TweenMax.fromTo($('.load'), 0.5, { css: { alpha: 1, display: 'none' } }, { css: { alpha: 0 }, ease: Power1.easeOut });
												} //end if.
												else {
														//CEP pesquisado nÃ£o foi encontrado.
														limpa_formulario_cep();
														alert("CEP não encontrado.");
												}
										});
								} //end if.
								else {
										//cep Ã© invÃ¡lido.
										limpa_formulario_cep();
										alert("Formato de CEP inválido.");
								}
						} //end if.
						else {
								//cep sem valor, limpa formulÃ¡rio.
								limpa_formulario_cep();
						}
				}
		}

		function EstadoSelecionado(inputCidades, estadoID, callBackFunction, loading) {
				if (!loading)
						loading = new Loading();

				setTimeout(function() {
						//do what you need here
				}, 2000);
				$.ajax({
						type: "GET",
						url: AjaxPath.CadastroCidades,
						data: { id: estadoID },
						success: function(data) {
								inputCidades.html('<option value="" class="hidden"></option>');
								$.each(data, function(index, value) {
										inputCidades.append('<option value="' + value.ID + '" data-nome="' + value.Nome + '">' + value.Nome + '</option>');
								});

								if (callBackFunction)
										callBackFunction(inputCidades);
								else
										loading.hide();
						}
				});
		}

		$('#name-nationality').on('change', function() {
				if ($(this).val() != '') {
						$("[data-component='foreign']").css('display', 'block');
				}
				if ($(this).val() != '35') {
						$('[name="cep"]').mask('999999999');
						$('[name="zip-code"]').mask('999999999');
						$('#nationality').val($(this).val());
						$('#cpf').val('');
						$('#cpf_fields').addClass('hidden');
						$('.zipCodeLabel').html('Zip Code');
				} else {
						$('[name="cep"]').mask('99999-999');
						$('[name="zip-code"]').mask('99999-999');
						$('#nationality').val($(this).val());
						$('#cpf_fields').removeClass('hidden');
						$('.zipCodeLabel').html('CEP');
				}
		})

		$('#modal_termos_e_condicoes').on('click', function() {
				if ($(this).hasClass('btn-green-2')) {
						var modal = $('#termos_e_condicoes');
						TweenMax.fromTo($('.modal-bg'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
						TweenMax.fromTo(modal, 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
						modal.addClass('fade');
						$('body').css('overflow-y', 'auto');
				}
		})

		$('.modal_termos_e_condicoes_close').on('click', function() {
				var modal = $('#termos_e_condicoes');
				modal.removeClass('fade');
				modal.hide();
				$('body').css('overflow', 'auto');
		})

		$('.modal_detalhes').on('click', function() {
				var modal = $('#' + this.dataset.modal);
				TweenMax.fromTo($('.modal-bg'), 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
				TweenMax.fromTo(modal, 0.5, { css: { alpha: 0, display: 'block' } }, { css: { alpha: 1 }, ease: Power1.easeOut });
				modal.addClass('fade');
				$('body').css('overflow', 'hidden');
		})

		$('.modal_detalhes_close').on('click', function() {
				var modal = $('#' + this.dataset.modal);
				$('.modal-bg').fadeOut();
				modal.removeClass('fade');
				modal.hide();
				$('body').css('overflow-y', 'auto');
		})
		$(".plans-table tr:even").css("background-color", "#ccc");
		$(".plans-table tr:odd").css("background-color", "#ddd");
		return init();
};
